
































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, namespace, State} from 'vuex-class';
import BUpload from 'buefy/src/components/upload/Upload.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import BSelect from 'buefy/src/components/select/Select.vue';

import {MAFUser} from '@/store/User/types';
import {LookupDistance, lookupIcon, LookupIcon} from '@/store/types';
import {User} from 'firebase';
import {DateTime} from 'luxon';
import {message} from '@/store/Friends/types'; // @ is an alias to /src
import uuid from 'uuid/v4';

/* tslint:disable:only-arrow-functions */

const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);
@Component({
    components: {
        BDropdown,
        BDropdownItem,
        BSelect,
        BField,
        BButton,
        BUpload,
    },
})
export default class UploadMessageModal extends Vue {
    @userNamespace.State('self') public readonly self!: MAFUser;
    @friendNamespace.State('currentlyChattingWith') public readonly friend!: MAFUser;
    @friendNamespace.Mutation('setCurrentlyChattingWith') public setCurrentlyChattingWith!: any;
    @friendNamespace.Action('createMessage') public createMessage!: any;

    @friendNamespace.Getter('getFriendMessages') public getFriendMessages!: any;
    @friendNamespace.Action('getFriendReference') public getFriendReference!: any;
    @friendNamespace.Action('sendEmailNotification') public sendEmailNotification!: any;


    public upload: any;
    public isLoading: boolean;
    public update: MAFUser;
    constructor() {
        super();
        this.upload = null;
        this.isLoading = false;
        this.update = this.self;
    }

    public onUpload(input: any) {
        const reader = new FileReader();
        reader.onload = function(e) {
            const image = document.getElementById('imageUpload');
            if (image && e && e.target) {
                image.setAttribute('src', reader.result as string);
            }
        };
        reader.readAsDataURL(input);
    }

    public async submit() {
        this.isLoading = true;
        const id = uuid();
        const uploaded = await this.$storage.ref().child(`messages/${id}`).put(this.upload);

        const sent = DateTime.local().toJSDate();
        const ref = await this.$firestore.collection('users').doc(this.friend.uid);
        const mes: message = new message(this.friend.uid, this.self.uid, sent , '', ref, false, id, null);
        await this.createMessage( mes.toPlainObj());
        this.sendEmailNotification({
            to: this.friend.email,
            mess: `Hello, ${this.friend.name}! ${this.self.name} has sent you an image. Log in and select ${(this.self && this.self.name) ? this.self.name.split(' ')[0] : 'them'} from your Messages menu to see the image and continue chatting.`,
        });

        this.isLoading = false;
         // @ts-ignore:
        this.$parent.close();
    }

    @Watch('upload')
    public onUploadChange() {
        this.onUpload(this.upload);
    }
}
